import axios from "axios";

// API Key for chat-related APIs
const API_KEY =
  process.env.REACT_APP_CHAT_API_KEY ||
  "4fe11e76e7740a23c45a5dee19cb6b19ae7a2e6000ce229cba165d5678454f59";
const BASE_URL =
  process.env.REACT_APP_CHAT_BASE_URL || "http://35.176.44.93:8001";

// Create axios instance with default config
const chatApi = axios.create({
  baseURL: BASE_URL,
  //   timeout: 30000, // 30 seconds timeout
  headers: {
    "Content-Type": "application/json",
    "X-API-Key": API_KEY,
  },
});

// Request interceptor to add auth token
chatApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auth_token"); // Get token from localStorage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Upload CSV file
export const uploadCSV = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await chatApi.post("api/fastapi/upload/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "X-API-Key": API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

// Analyze data with exact payload format
export const analyzeData = async (filename) => {
  try {
    // Ensure we send exactly the required Here is insight for Target vs. Achievement analysis for different types of loans, categorized by Product-wise, Region-wise, and Branch-wise performance:
    const payload = {
      filename: filename,
    };

    const response = await chatApi.post("/analyze", payload);
    return response.data;
  } catch (error) {
  
    throw error?.response?.data || error;
  }
};

// API endpoints
export const sendMessage = async (message) => {
  try {
    const response = await chatApi.post("chat/send-message/", {
      message,
    });
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

// Helper function to set/update token
export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem("auth_token", token);
  } else {
    localStorage.removeItem("auth_token");
  }
};

export default chatApi;


